import {Injectable} from '@angular/core';
import {ApiClientService} from './api-client.service';
import {Amenity, NetworkEntity} from '../types/data.types';
import {UrlService} from './url.service';
import {EmptyRowService} from './empty-row.service';
import {ConstantsService} from './constants.service';
import {AccountPermissionsService} from './account-permissions.service';
import {ResidentService} from './resident.service';
import {AuthenticationService} from './authentication.service';
import {Observable} from 'rxjs/Observable';
import {filter, tap} from 'rxjs/operators';
import {createInitialNetworkEntity, resolveNetworkEntity} from './helper-functions';

declare const toastr: any;
declare const swal: any;
declare const $: any;

@Injectable()
export class MaintenanceCalendarService {
    view = 'calendar';
    isAmenityModalShow = false;
    isAmenityViewShow = false;
    isAmenityPaymentShow = false;
    isAmenityDepositChargeShow = false;
    isPrefilledFromDirectory = false;

    amenityInAmenityModal: Amenity;

    data = {
        allAmenities: {
            get: '/v1/booking.json?expand=amenity,building,suite,resident,createdBy,notes,notes.createdBy,payments,payments.transactions,payments.transactions.createdBy',
            data: [],
            total: null
        },
    };
    tabId = 'allAmenities';
    spinnerShow = true;
    showServiceUnavailable = false;
    buildings: Array<any> = [];
    buildingsForRead: Array<any> = [];
    buildingsForUpdate: Array<any> = [];
    eventsForCalendar: Array<any> = [];
    serviceName: string = 'amenity';
    amenitiesList = [];
    amenitiesByBuilding = [];
    amenitiesListForModal = [];
    modalAmenitiesLoadingSpinnerShow = false;
    calendarSpinnerShow = false;
    calendarBookings = [];
    calendarViewRequestSubscription = null;
    monthsArray: Array<string> = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    arrayOfMonthsLastDays: Array<number> = [
        31,
        new Date().getFullYear() % 4 == 0 ? 29 : 28,
        31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    prefilledDateFromCaledar = '';
    calendarDisabledDatesSubscription = null;
    disabledDatesArray = [];

    constructor(
        public api: ApiClientService,
        public urlService: UrlService,
        public emptyRowService: EmptyRowService,
        public account: AccountPermissionsService,
        private residentService: ResidentService,
        private authenticationService: AuthenticationService
    ) {
        this.api.onLogout.subscribe(() => this.buildings = []);
    }

    getData() {
        this.getDataByQueryParams().subscribe();
    }

    getDataByQueryParams(): Observable<NetworkEntity<any>> {
        this.showServiceUnavailable = false;
        this.data[this.tabId].total = null;
        const tabId = this.urlService.queryParams['tab'];
        const url = this.data[tabId].get;
        const queryParams = this.urlService.getQueryParamsString();

        const resident = this.authenticationService.userIsResident;
        const selectedBuilding = JSON.parse(localStorage.getItem('residentselectedBuilding'));
        let sortedDateResident = '';
        if (resident && selectedBuilding) {
            sortedDateResident = `&building_id=${selectedBuilding.buildingId}&suite_id=${selectedBuilding.suite_id}`;
        } else if (resident && !selectedBuilding)
            return;
        return this.api.getJson('domainAmenities', `${url}${queryParams}${resident ? sortedDateResident : ''}`).pipe(
            createInitialNetworkEntity(),
            resolveNetworkEntity(
                item => {
                    if (item.building && item.building.bdId) {
                        item.building.id = item.building.bdId;
                    }
                    return Amenity.fromMaintenanceBookingData(this.account.addPermissionsToEntity(item, this.serviceName));
                }
            ),
            tap(({loading}) => this.spinnerShow = loading),
            tap(
                (res) => {
                    this.data[tabId].data = res.entities;
                    this.data[tabId].total = res.total;
                    this.emptyRowService.fillEmptyRow();
                    if ($('.table')[0])
                        $('.table')[0].scrollIntoView();
                },
                (error) => {
                    this.spinnerShow = false;
                    this.showServiceUnavailable = true;
                    this.api.errorHandler(error, 'Failed get Amenity Reports');
                }
            ),
            filter(({finished}) => finished),
            tap((res) => {
                if (this.amenityInAmenityModal && this.view != 'calendar') {
                    const amenityInAmenityModal = res.entities.find(item => item.id === this.amenityInAmenityModal.id);
                    if (amenityInAmenityModal) {
                        this.amenityInAmenityModal = {
                            ...amenityInAmenityModal
                        };
                    }
                }
            })
        );
    }

    bookingsFactory(entities: any, targetArray) {
        entities.forEach((booking) => targetArray.push(Amenity.fromMaintenanceBookingData(booking)));
    }

    getBuildings(): void {
        this.buildings = [];
        if (this.authenticationService.userIsResident) {
            this.buildings.push({
                id: this.residentService.selectedBuilding.buildingId,
                name: this.residentService.selectedBuilding.buildingName
            });
        } else {
            const url = `/v1/building_defined_amenity.json?per-page=1000&order-by=buildingName|asc`;
            this.api.get('domainAmenities', url).subscribe(
                (res) => {
                    if (res._body && JSON.parse(res._body).length) {
                        JSON.parse(res._body).filter((building) => {
                            if (building.buildingId && building.buildingName) {
                                this.buildings.push({
                                    id: building.buildingId,
                                    name: building.buildingName
                                });
                            }
                        });
                    }
                    this.getFilteredBuildings();
                },
                (error) => this.api.errorHandler(error, 'Failed get buildings')
            );
        }
    }

    resetData() {
        for (const item in this.data) {
            this.data[item].data = [];
            this.data[item].total = null;
        }
    }

    editAmenity(amenity: Amenity) {
        this.isAmenityModalShow = true;
        this.amenityInAmenityModal = Object.assign({}, amenity);
    }

    showDepositChargeModal(amenity: Amenity) {
        this.isAmenityDepositChargeShow = true;
        this.amenityInAmenityModal = Object.assign({}, amenity);
    }

    showPaymentModal(amenity: Amenity) {
        this.isAmenityPaymentShow = true;
        this.amenityInAmenityModal = Object.assign({}, amenity);
    }

    deleteAmenity(id: number): void {
        if (!id) return;
        swal(ConstantsService.getSwalConfig('Delete Amenity Booking'),
            () => {
                const url = `/v1/booking/${id}.json`;
                this.api.remove('domainAmenities', url).subscribe(
                    () => {
                        toastr.success('Amenity Booking has been deleted.');
                        this.getData();
                    },
                    (error) => {
                        const body = JSON.parse(error._body);
                        let errorMessage = 'Delete Amenity Booking failed';
                        if (body && body.message) {
                            if (body.message === 'You can\'t delete a booking with paid payments')
                                errorMessage = 'Paid booking cannot be deleted before a refund(s) was issued. Please go to the \'payment\' menu and issue the refund(s).';
                            // else
                            //     errorMessage = body.message;
                        }
                        this.api.errorHandler(error, errorMessage);
                    }
                );
            }
        );
    }

    getPDF(id: number): void {
        if (!id) return;
        const url = `/v1/incident-reports-pdf/${id}.json`;
        this.api.get('domainIncidentReports', url).subscribe(
            (res) => {
                const pdfUrl = JSON.parse(res._body).path;
                const _src = `https://docs.google.com/viewer?url=${pdfUrl}&embedded=true`;
                window.open(_src);
            },
            (error) => this.api.errorHandler(error, 'View Pdf operation failed')
        );
    }

    canEdit(buildingId?: number) {

        return this.account.canUpdate(this.serviceName, buildingId);
    }

    canDelete(buildingId?: number) {

        return this.account.canDelete(this.serviceName, buildingId);
    }

    getFilteredBuildings() {
        this.buildingsForRead = this.account.getBuildingsForRead(this.buildings, this.serviceName);
        this.buildingsForUpdate = this.account.getBuildingsForUpdate(this.buildings, this.serviceName);
    }

    getAmenitiesList(): void {
        const residentInfo = `&building_id=${this.residentService.selectedBuilding.buildingId}`;
        const residentBuilding = this.residentService.selectedBuilding.buildingId;
        const url = `/v1/amenity?expand=buildingAmenity,fees&enable_status=1${residentBuilding ? residentInfo : ''}`;

        this.api.get('domainAmenities', `${url}`).subscribe(
            (res) => {
                const body = JSON.parse(res._body);
                const entities = body.entities;
                this.amenitiesList = [];
                entities.map(item => {
                    this.amenitiesList.push(item);
                });
                this.spinnerShow = false;
            },
            (error) => this.api.errorHandler(error, 'Failed get Amenity List')
        );
    }

    getAmenitiesListByBuilding(buildingId): void {
        this.modalAmenitiesLoadingSpinnerShow = true;
        this.amenitiesListForModal = [];
        const residenntInfo = this.residentService.selectedBuilding.buildingId;
        const url = `/v1/amenity?expand=buildingAmenity,fees&enable_status=1&per-page=1000&building_id=${residenntInfo || buildingId}`;
        this.api.get('domainAmenities', `${url}`).subscribe(
            (res) => {
                this.amenitiesByBuilding = [];
                const body = JSON.parse(res._body);
                const entities = body.entities;
                const amenitiestoChooseFromArray = [];
                entities.map(item => {
                    if (!this.authenticationService.userIsResident || (this.authenticationService.userIsResident && item.allowResidentsToBook))
                        amenitiestoChooseFromArray.push(item);
                });
                this.amenitiesByBuilding = JSON.parse(JSON.stringify(amenitiestoChooseFromArray));
                while (amenitiestoChooseFromArray.length) {
                    this.amenitiesListForModal.push(amenitiestoChooseFromArray.splice(0, 3));
                }
                this.modalAmenitiesLoadingSpinnerShow = false;
            },
            (error) => this.api.errorHandler(error, 'Failed get Amenity List For Booking')
        );
    }

    getEventsListParsed(calendarBookings): Array<any> {
        const formated = [];
        calendarBookings.filter((booking) => {
            formated.push({
                title: booking.suiteNumber + ' - ' + booking.amenityName,
                start: new Date(booking.dateFrom).toISOString(),
                end: new Date(booking.dateTo).toISOString(),
                backgroundColor: this.getAmenityColorFromAmenityList(booking),
                borderColor: this.getAmenityColorFromAmenityList(booking),
                className: booking.status,
                id: booking.id,
                booking: booking
            });
        });
        return formated;
    }

    getAmenityNameFromAmenityList(booking): string {
        let amenityName = '';
        this.amenitiesList.filter((amenity) => {
            if (amenity.id == booking.amenityId)
                amenityName = booking.amenityName;
        });
        return amenityName;
    }

    getAmenityColorFromAmenityList(booking): string {
        let amenityColor = '#1ab394';
        this.amenitiesList.filter((amenity) => {
            if (amenity.id == booking.amenityId)
                amenityColor = amenity.amenityColor;
        });
        return amenityColor;
    }

    getAmenitiesForCalendarResident() {
        const monthChangedTo = this.monthsArray.indexOf((<any>document.getElementsByClassName('calendar-wrapper')[0].childNodes[1].childNodes[0].childNodes[0].childNodes[0]).innerText.split(' ')[0]);
        const yearChangedTo = parseInt((<any>document.getElementsByClassName('calendar-wrapper')[0].childNodes[1].childNodes[0].childNodes[0].childNodes[0]).innerText.split(' ')[1]);
        const startDateForSending = new Date(new Date(yearChangedTo, monthChangedTo, 1).getTime() - new Date(yearChangedTo, monthChangedTo, 1).getTimezoneOffset() * 60000);
        const endDateForSending = new Date(new Date(yearChangedTo, monthChangedTo, this.arrayOfMonthsLastDays[monthChangedTo], 23, 59).getTime() - new Date(yearChangedTo, monthChangedTo, 1).getTimezoneOffset() * 60000);
        this.calendarSpinnerShow = true;
        const query = this.urlService.queryParams['query'] ? `&query=*${this.urlService.queryParams['query']}*` : '';
        const amenityId = this.urlService.queryParams['amenity_id'] ? `&${this.urlService.getAmenityIdQueryString(this.urlService.queryParams['amenity_id'])}` : '';
        const selectedBuilding = `&building_id=${this.residentService.selectedBuilding.buildingId}&suite_id=${this.residentService.selectedBuilding.suite_id}`;
        const url = `/v1/calendar_view.json?bookingDateFrom=>=+${startDateForSending.toISOString()}&bookingDateTo=<=+${endDateForSending.toISOString()}${query}${amenityId}${this.residentService.selectedBuilding ? selectedBuilding : ''}`;

        this.api.get('domainAmenities', `${url}`).subscribe(
            (res) => {
                this.calendarBookings = [];
                this.eventsForCalendar = [];
                const body = JSON.parse(res._body);
                if (body && body.entities && body.entities.length > 0) {
                    this.eventsForCalendar = body.entities.map(item => ({
                        title: item.title,
                        start: new Date(item.start).toISOString(),
                        end: new Date(item.end).toISOString(),
                        backgroundColor: item.amenityColor,
                        borderColor: item.amenityColor,
                        className: item.currentUserBooking ? item.status : 'not-available',
                        id: item.id,
                        currentUserBooking: item.currentUserBooking
                    }));
                }
                if (this.amenityInAmenityModal && this.view == 'calendar') {
                    this.calendarBookings.filter((item) => {
                        if (this.amenityInAmenityModal.id == item.id)
                            this.amenityInAmenityModal = Object.assign({}, item);
                    });
                }
                this.calendarSpinnerShow = false;
                // Added the resize event, because the spinner does not disappear, until the mouse is hovered
                window.dispatchEvent(new Event('resize'));
                this.getDisabledDatesForCalendar(startDateForSending, endDateForSending);
            },

            (error) => this.api.errorHandler(error, 'Failed get Amenity Reports')
        );
    }

    getAmenitiesForCalendar(): void {
        this.calendarSpinnerShow = true;
        if (this.calendarViewRequestSubscription)
            this.calendarViewRequestSubscription.unsubscribe();
        if (this.amenitiesList.length) {
            const monthChangedTo = this.monthsArray.indexOf((<any>document.getElementsByClassName('calendar-wrapper')[0].childNodes[1].childNodes[0].childNodes[0].childNodes[0]).innerText.split(' ')[0]);
            const yearChangedTo = parseInt((<any>document.getElementsByClassName('calendar-wrapper')[0].childNodes[1].childNodes[0].childNodes[0].childNodes[0]).innerText.split(' ')[1]);
            const startDateForSending = new Date(new Date(yearChangedTo, monthChangedTo, 1).getTime() - new Date(yearChangedTo, monthChangedTo, 1).getTimezoneOffset() * 60000);
            const endDateForSending = new Date(new Date(yearChangedTo, monthChangedTo, this.arrayOfMonthsLastDays[monthChangedTo], 23, 59).getTime() - new Date(yearChangedTo, monthChangedTo, 1).getTimezoneOffset() * 60000);
            const url = `/v1/booking.json?expand=amenity,building,suite,resident,createdBy,notes,notes.createdBy,payments,payments.transactions,payments.transactions.createdBy&bookingDateFrom=>= ${startDateForSending.toISOString()}&bookingDateTo=<= ${endDateForSending.toISOString()}`;
            const queryParams = this.urlService.getQueryParamsString();
            const leftPart = '&page=1&per-page=1000';
            const rightPart = queryParams.split('per-page=')[1].split('&');
            let rightPartString = '';
            if (rightPart.length > 1) {
                for (let i = 1; i < rightPart.length; i++) {
                    rightPartString += '&' + rightPart[i];
                }
            }
            const sortedByBuilding = `&building_id=${this.residentService.selectedBuilding.buildingId}&suite_id=${this.residentService.selectedBuilding.suite_id}`;
            const queryParams1000PerPage = leftPart + rightPartString;
            this.calendarViewRequestSubscription = this.api.get('domainAmenities', `${url}${queryParams1000PerPage}${this.residentService.selectedBuilding.buildingId ? sortedByBuilding : ''}`).subscribe(
                (res) => {
                    this.calendarBookings = [];
                    this.eventsForCalendar = [];
                    const body = JSON.parse(res._body);
                    const entities = body.entities;
                    const calendarBookings = [];
                    this.emptyRowService.fillEmptyRow();
                    entities.map(item => {
                        if (item.building && item.building.bdId) return item.building.id = item.building.bdId;
                    });
                    this.account.addEntitiesPermissions(entities, this.serviceName);
                    this.bookingsFactory(entities, calendarBookings);
                    this.calendarBookings = calendarBookings;
                    this.eventsForCalendar = this.getEventsListParsed(this.calendarBookings);
                    if (this.amenityInAmenityModal && this.view == 'calendar') {
                        this.calendarBookings.filter((item) => {
                            if (this.amenityInAmenityModal.id == item.id)
                                this.amenityInAmenityModal = Object.assign({}, item);
                        });
                    }
                    this.calendarSpinnerShow = false;
                    // Added the resize event, because the spinner does not disappear, until the mouse is hovered
                    window.dispatchEvent(new Event('resize'));
                    this.getDisabledDatesForCalendar(startDateForSending, endDateForSending);
                },
                (error) => this.api.errorHandler(error, 'Failed get Amenity Reports')
            );
        } else
            this.updateAmenitiesAndBookings();
    }

    updateAmenitiesAndBookings(): void {
        const monthChangedTo = this.monthsArray.indexOf((<any>document.getElementsByClassName('calendar-wrapper')[0].childNodes[1].childNodes[0].childNodes[0].childNodes[0]).innerText.split(' ')[0]);
        const yearChangedTo = parseInt((<any>document.getElementsByClassName('calendar-wrapper')[0].childNodes[1].childNodes[0].childNodes[0].childNodes[0]).innerText.split(' ')[1]);
        const startDateForSending = new Date(new Date(yearChangedTo, monthChangedTo, 1).getTime() - new Date(yearChangedTo, monthChangedTo, 1).getTimezoneOffset() * 60000);
        const endDateForSending = new Date(new Date(yearChangedTo, monthChangedTo, this.arrayOfMonthsLastDays[monthChangedTo], 23, 59).getTime() - new Date(yearChangedTo, monthChangedTo, 1).getTimezoneOffset() * 60000);
        const url = `/v1/booking.json?expand=amenity,building,suite,resident,createdBy,notes,notes.createdBy,payments,payments.transactions,payments.transactions.createdBy&bookingDateFrom=>= ${startDateForSending.toISOString()}&bookingDateTo=<= ${endDateForSending.toISOString()}`;
        const queryParams = this.urlService.getQueryParamsString();
        const leftPart = '&page=1&per-page=1000';
        const rightPart = queryParams.split('per-page=')[1].split('&');
        let rightPartString = '';
        if (rightPart.length > 1) {
            for (let i = 1; i < rightPart.length; i++) {
                rightPartString += '&' + rightPart[i];
            }
        }
        const queryParams1000PerPage = leftPart + rightPartString;
        this.calendarViewRequestSubscription = this.api.get('domainAmenities', `${url}${queryParams1000PerPage}`).subscribe(
            (res) => {
                this.calendarBookings = [];
                const body = JSON.parse(res._body);
                const entities = body.entities;
                const calendarBookings = [];
                this.emptyRowService.fillEmptyRow();
                entities.map(item => {
                    if (item.building && item.building.bdId) return item.building.id = item.building.bdId;
                });
                this.account.addEntitiesPermissions(entities, this.serviceName);
                this.bookingsFactory(entities, calendarBookings);
                this.calendarBookings = calendarBookings;

                const url = `/v1/amenity?expand=buildingAmenity,fees&enable_status=1`;
                this.api.get('domainAmenities', `${url}`).subscribe(
                    (res) => {
                        this.eventsForCalendar = [];
                        const body = JSON.parse(res._body);
                        const entities = body.entities;
                        this.amenitiesList = [];
                        entities.map(item => {
                            this.amenitiesList.push(item);
                        });
                        this.eventsForCalendar = this.getEventsListParsed(this.calendarBookings);
                        this.calendarSpinnerShow = false;
                        this.getDisabledDatesForCalendar(startDateForSending, endDateForSending);
                    },
                    (error) => this.api.errorHandler(error, 'Failed get Amenity List')
                );
            },
            (error) => this.api.errorHandler(error, 'Failed get Amenity Reports')
        );
    }

    updateAmenityColor(amenityId, color): void {
        this.amenitiesList.filter((amenity) => {
            if (amenity.id == amenityId) {
                amenity.amenityColor = color;
                this.eventsForCalendar = this.getEventsListParsed(this.calendarBookings);
                this.eventsForCalendar = this.eventsForCalendar.concat(this.disabledDatesArray);
                $('#ucCalendar').fullCalendar('removeEvents');
                $('#ucCalendar').fullCalendar('addEventSource', this.eventsForCalendar);
            }
        });
    }

    getDisabledDatesForCalendar(start, end) {
        this.disabledDatesArray = [];
        const url = `/v1/disabled_dates.json?filterDateFrom=>=${start.toISOString()}&filterDateTo=<=${end.toISOString()}`;
        if (this.calendarDisabledDatesSubscription)
            this.calendarDisabledDatesSubscription.unsubscribe();
        this.calendarDisabledDatesSubscription = this.api.get('domainAmenities', url).subscribe(
            res => {
                const body = JSON.parse(res._body);
                body.entities.forEach(item => {
                    const e = {
                        title: item.amenityName + (!this.authenticationService.userIsResident ? ' - Blocked Time slot' : ''),
                        amenityId: item.amenityId,
                        start: item.startDate,
                        end: item.endDate,
                        disabledDateId: item.id,
                        booking: {},
                        disabledDate: true,
                        note: item.note,
                        backgroundColor: !this.authenticationService.userIsResident ? '#000000' : '#c0c0c0',
                        borderColor: !this.authenticationService.userIsResident ? '#000000' : '#c0c0c0'
                    };
                    this.disabledDatesArray.push(e);
                    this.eventsForCalendar.push(e);
                });
                $('#ucCalendar').fullCalendar('removeEvents');
                $('#ucCalendar').fullCalendar('addEventSource', this.eventsForCalendar);
            }, error => this.api.errorHandler(error, 'Failed to get diabled dates for amenities in current month.')
        );
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/maintenance-calendar.service.ts